import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  // address: [],
  loading: false,
  addBtnLoading: false,
  removeBtnLoading: false,
  wishlist: [],
  leadsexhaustedwishlist: false,
  limitwishlist: 8,
  lastDocwishlist: null,
  loadMoreWhislist: false,
  wishlistproducts: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_WHISLIST:
      return updateObject(state, action.payload);
    case actionTypes.ADD_TO_WHISLIST:
      return updateObject(state, action.payload);
    case actionTypes.REMOVE_FROM_WHISLIST:
      return updateObject(state, action.payload);
    case actionTypes.ACCOUNT_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
